<template>
  <div class="register-form">
    <Header :title="title" :right-content="rightContent" />
    <div class="prompt">
      <img src="@/assets/images/template/a_top_remind.png"></img><span>请正确选择电子钱包链类型网络， 错误类型将会导致无法取回资金。</span>
    </div>
    <div
      v-if="registerSuccess === null"
      ref="registerForm"
      class="register-body"
    >
      <div class="form-row">
        <label>手机号</label>
        <input
          class="input"
          :value="mobilePhoneNum.replace(/(\d{7})(\d{4})/g, '**** $2')"
          placeholder="请输入手机号码"
          disabled
          style="text-align: right; border: none"
        >
      </div>
      <div class="form-row">
        <label>链类型</label>
        <div class="select">
          <select id="usdt-blockchain" v-model="protocol">
            <option value="ERC20">ERC20</option>
            <option value="TRC20">TRC20</option>
            <!-- <option value="OMNI">OMNI</option> -->
          </select>
        </div>
      </div>
      <div class="form-row">
        <label>钱包地址</label>
        <input
          id="usdt-wallet-address"
          v-model="eWalletAddress"
          class="input"
          placeholder="长按粘贴钱包地址，避免出错"
        >
      </div>
      <div class="form-row">
        <label>钱包类型</label>
        <div class="select">
          <select v-model="selectedWalletCompany">
            <option v-for="walletCompany in walletCompanies" :key="walletCompany.walletCompany" :value="walletCompany.walletCompany">{{ walletCompany.walletCompanyName }}</option>
            <!-- <option :value="'other'">其他</option> -->
          </select>
        </div>
      </div>
      <div v-if="false" class="form-row">
        <label>錢包名稱</label>
        <input
          id="usdt-wallet-company-name"
          v-model="walletCompanyName"
          class="input"
          placeholder="请输入錢包名稱"
        >
      </div>
      <div class="form-row verify-code">
        <label>短信验证码</label>
        <VerifyCode
          id="usdt-code"
          :phone="mobilePhoneNum"
          :account-number="user.loginname"
          :code-type="'bindBCVerifyCode'"
          @changeCode="changeCode"
        />
      </div>
      <div class="form-row flex-center">
        <button
          class="form-button"
          style="margin-top: 1rem; width: 90%; max-width: 300px"
          @click="registerWallet"
        >
          提交
        </button>
      </div>
      <br>
      <p class="red flex-center">{{ registerErrorMsg }}</p>
    </div>
    <div v-else class="register-result">
      <div class="form-row flex-center">
        <img
          class="icon"
          :src="
            registerSuccess
              ? require('@/assets/images/wallet/success.png')
              : require('@/assets/images/wallet/fail.png')
          "
        >
      </div>
      <br>
      <div class="form-row flex-center">
        <p v-if="registerSuccess" style="font-size: 0.35rem">
          电子钱包添加成功
        </p>
        <p v-else style="font-size: 0.35rem">
          电子钱包添加<span style="color: red">失敗</span>
        </p>
      </div>
      <div class="form-row flex-center">
        <button
          v-if="registerSuccess && !toDeposit && fromWithdraw"
          class="form-button result-button"
          @click="backToWithDraw"
        >
          继续取款
        </button>
        <button
          v-if="registerSuccess && toDeposit"
          class="form-button result-button"
          @click="backToDeposit"
        >
          继续存款
        </button>
      </div>
    </div>
    <!-- <AlertPop
      :model="selectedWalletCompany == 'other'"
      :button1-txt="'联系客服'"
      :button2-txt="'关闭'"
      :use-slot="true"
      @alertOnClose="alertBoxClose"
      @button1Evt="openLive800"
      @button2Evt="alertBoxClose"
    >
      <div>
        如您使用的钱包不在列表,请联系客服协助
      </div>
    </AlertPop> -->
  </div>
</template>
<script>
require('@/assets/css/registerUSDT.css')
import Header from '@/view/module/Header.vue'
import api from '@/plugins/api'
import VerifyCode from '@/view/module/VerifyCode.vue'
// import utils from "@/utils/tradeDataUtil";
import { mapState } from 'vuex'
import AlertPop from '@/view/module/AlertPop.vue'
export default {
  name: 'RegisterUSDT',
  components: { Header, VerifyCode, AlertPop },
  props: ['source'],
  computed: {
    ...mapState(['pageType', 'version', 'sourceType', 'user']),
    mobilePhoneNum: {
      get() {
        return this.user.mobilePhone
        // return "17452302152";
      }
    }
  },
  watch: {
    eWalletAddress(val) {
      this.eWalletAddress = val.replace(/\s+/g, '')
    }
  },
  data() {
    return {
      title: '添加电子钱包',
      rightContent: 'ewallet',
      protocol: 'ERC20',
      eWalletAddress: '',
      verifyCode: '',
      timer: null,
      registerSuccess: null,
      registerErrorMsg: '',
      isAndroid:
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Linux') > -1,
      walletCompanies: [],
      selectedWalletCompany: null,
      walletCompanyName: null,
      toDeposit: this.$route.query.toDeposit || false,
      fromWithdraw: this.$route.query.fromWithdraw || false
    }
  },
  mounted() {
    api.getSupportWalletList().then(res => {
      if (res.data.code == 200) {
        this.$bus.$emit('loading', true)
        this.walletCompanies = res.data.data
        this.selectedWalletCompany = this.walletCompanies[0].walletCompany
      }
    })
  },
  methods: {
    changeCode(code) {
      this.verifyCode = code
    },
    warning(target) {
      const ele = this.$refs.registerForm.querySelector(`#${target}`)
      ele.classList.add('warn')
      const handleRemove = (evt) => {
        evt.target.classList.remove('warn')
        evt.target.removeEventListener('transitionend', handleRemove)
      }
      ele.addEventListener('transitionend', handleRemove)
    },
    checkWalletAddress() {
      const { eWalletAddress, protocol } = this
      // return eWalletAddress.startsWith("0x")
      switch (protocol) {
        // case "ERC20": {
        //   return eWalletAddress.startsWith("0x");
        // }
        // case "OMNI": {
        //   return new RegExp(/^[1,3]{1}\w+/).test(eWalletAddress);
        // }
        case 'TRC20':
          return eWalletAddress.startsWith('T')
        default:
          return eWalletAddress.startsWith('0x')
      }
    },
    registerWallet() {
      if (this.mobilePhoneNum === '' || this.mobilePhoneNum.length < 11) {
        this.registerErrorMsg = '请输入有效的电话号码'
        return
      }
      if (this.protocol === '') {
        this.registerErrorMsg = '请选取有效的链类型'
        this.warning('usdt-blockchain')
        return
      }
      if (this.eWalletAddress === '') {
        this.registerErrorMsg = '请输入有效钱包地址'
        this.warning('usdt-wallet-address')
        return
      } else {
        const res = this.checkWalletAddress()
        if (res === false) {
          this.registerErrorMsg = '请输入有效的USDT地址'
          this.warning('usdt-wallet-address')
          return
        }
      }
      if (this.selectedWalletCompany == 'other' && (!this.walletCompanyName || this.walletCompanyName == '')) {
        this.registerErrorMsg = '请输入有效錢包名稱'
        this.warning('usdt-wallet-company-name')
        return
      }
      if (this.verifyCode === '' || this.verifyCode.length < 4) {
        this.registerErrorMsg = '请输入有效的验证码'
        this.warning('usdt-code')
        return
      }
      const data = {
        code: this.verifyCode,
        walletAddress: this.eWalletAddress,
        protocol: this.protocol || 'ERC20',
        walletCompany: this.selectedWalletCompany != 'other' ? this.selectedWalletCompany : this.walletCompanyName
        // walletCompany: this.protocol
      }
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        isAjax: true
      }
      api.addWallet(this.$qs.stringify(data), headers).then((res) => {
        if (res.data.code === 200) {
          this.registerSuccess = true
        } else {
          this.registerErrorMsg = res.data.code_desc
          // this.registerSuccess = false;
        }
      })
    },
    backToWithDraw() {
      this.$router.push({ path: '/home/withdrawal' })
    },
    backToDeposit() {
      this.$router.push({ path: '/home/recharge' })
    },
    alertBoxClose() {
      this.selectedWalletCompany = this.walletCompanies[0].walletCompany
    },
    openLive800() {
      var url =
      `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = screen.width / 2 - 600 / 2
      var top = screen.height / 2 - 400 / 2
      window.open(
        url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' +
          top +
          ', left=' +
          left
      )
    },
  }
}
</script>
